import { useEffect, useState } from 'react';

const ecommStatesList = ['FL', 'NV', 'NJ', 'TX'];

interface IWindow extends Window {
  cloudFrontUserState: string;
  cloudFrontUserCountry: string;
  cloudFrontUserZipCode: string;
}

export interface userLocationInterface {
  userLocation: userLocationType | null;
  setUserLocation: (userLocation?: userLocationType) => void;
}

export type userLocationType = {
  state?: string | null;
  country?: string | null;
  zipCode?: string | null;
};

enum userLocationEnum {
  STATE = 'userState',
  ZIPCODE = 'userZipCode',
  COUNTRY = 'userCountry',
}

const useEcommMarket = () => {
  const [userState, setUserStateValue] = useState<string | null>();
  const [userCountry, setUserCountryValue] = useState<string | null>();
  const [userZipCode, setUserZipCodeValue] = useState<string | null>();

  const getCloudfrontUserLocation = () => {
    const windowUser = window as unknown as IWindow;
    const windowUserState = windowUser.cloudFrontUserState;
    const windowUserCountry = windowUser.cloudFrontUserCountry;
    const windowUserZipCode = windowUser.cloudFrontUserZipCode;

    if (!userCountry) {
      setUserCountryValue(windowUserCountry);
      sessionStorage.setItem(userLocationEnum.COUNTRY, windowUserCountry);
    }

    const updateUserZipCode = !userZipCode || userZipCode !== windowUserZipCode;
    const updateUserState = !userState || userState !== windowUserState;

    if (updateUserZipCode || updateUserState) {
      const sessionStorageUserState = sessionStorage.getItem(
        userLocationEnum.STATE
      );
      const sessionStorageUserZipCode = sessionStorage.getItem(
        userLocationEnum.ZIPCODE
      );

      if (sessionStorageUserState || sessionStorageUserZipCode) {
        setUserStateValue(sessionStorageUserState);
        setUserZipCodeValue(sessionStorageUserZipCode);
        return;
      }
      sessionStorage.setItem(userLocationEnum.STATE, windowUserState);
      setUserStateValue(windowUserState);
      sessionStorage.setItem(userLocationEnum.ZIPCODE, windowUserZipCode);
      setUserZipCodeValue(windowUserZipCode);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Automated migration to Biome
  useEffect(() => {
    getCloudfrontUserLocation();
  }, []);

  const setUserLocation = (location?: userLocationType) => {
    // biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome
    if (location && location.state && location.zipCode) {
      sessionStorage.setItem(userLocationEnum.STATE, location.state);
      setUserStateValue(location.state);
      sessionStorage.setItem(userLocationEnum.ZIPCODE, location.zipCode);
      setUserZipCodeValue(location.zipCode);
    } else {
      sessionStorage.setItem(userLocationEnum.STATE, '');
      sessionStorage.setItem(userLocationEnum.ZIPCODE, '');
      getCloudfrontUserLocation();
    }
  };

  const userLocation = {
    state: userState,
    zipCode: userZipCode,
    country: userCountry,
  };

  return {
    isInEcommMarket: userState && ecommStatesList.includes(userState),
    userLocation,
    setUserLocation,
  };
};

export default useEcommMarket;
